import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';

// Fix to access .default if returned as a module
const importAll = (r) => r.keys().map((key) => r(key).default || r(key));
const logoImages = importAll(
  require.context('../images/logos/clients', false, /\.(png|jpe?g|svg)$/)
);

const LogoSlider = () => (
  <div style={{ background: 'transparent', padding: '2rem 0' }}>
    <Swiper
      modules={[Autoplay]}
      spaceBetween={30}
      slidesPerView={5}
      loop={true}
      autoplay={{ delay: 2000, disableOnInteraction: false }}
      breakpoints={{
        320: { slidesPerView: 2 },
        640: { slidesPerView: 3 },
        1024: { slidesPerView: 5 },
      }}
    >
      {logoImages.map((src, index) => (
        <SwiperSlide key={index}>
        <img
  src={src}
  alt={`Logo ${index + 1}`}
  style={{
    height: '80px',           // ⬆️ more visual presence
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain',
    margin: '0 auto',
    padding: '0px',
    transition: 'filter 0.3s ease-in-out',
  }}
/>
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default LogoSlider;
